import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './index.css';
import { api } from '../../services/api';
import InputMask from 'react-input-mask';
import Avaliacao from '../Avaliacao';

import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';

function DadosRestaurante() {
  const [codigorest, setCodigoRest ] = useState(0);
  const [codigo, setCodigo] = useState(0);
  const [cnpj, setCNPJ] = useState(0);
  const [razao, setRazao] = useState('');
  const [responsavel, setResponsavel] = useState('');
  const [email, setEmail] = useState('');
  const [codigoerp, setErp] = useState(0);
  const [endereco, setEndereco] = useState('');
  const [lojas, setLojas] = useState([]);
  const [avaliacao, setAvaliacao] = useState(0);
  const onlyNumbers = (str) => str.replace(/[^0-9]/g, '');
  const navigate = useNavigate()



  function formatLeadingZero(text) {

    if (text.length === 13) {
      return `0${text}`;
    } else
      if (parseInt(text) < 100) {
        return `0${text}`;
      } else {
        return `${text}`;
      }
  }

  function GeraEstrela(numero) {
    if (parseFloat(numero) > 4.5) {
      return <div >
        <ul className="list-unstyled list-inline social text-center">
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-av"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-av"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-av"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-av"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-av"></i></li>
          <h1 className="avalia-detalhe">{(numero)}</h1>
        </ul>
      </div>;
    } else if (parseFloat(numero) > 3.50) {
      return <div >
        <ul className="list-unstyled list-inline social text-center">
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-av"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-av"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-av"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-av"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-notav"></i></li>
          <h1 className="avalia-detalhe">{numero}</h1>
        </ul>
      </div>;
    } else if (parseFloat(numero) > 2.5) {
      return <div >
        <ul className="list-unstyled list-inline social text-center">
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-av"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-av"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-av"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-notav"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-notav"></i></li>
          <h1 className="avalia-detalhe">{numero}</h1>
        </ul>
      </div>;
    } else if (parseFloat(numero) > 1.5) {
      return <div >
        <ul className="list-unstyled list-inline social text-center">
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-av"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-av"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-notav"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-notav"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-notav"></i></li>
          <h1 className="avalia-detalhe">{numero}</h1>
        </ul>
      </div>;
    } else if (parseFloat(numero) > 0) {
      return <div >
        <ul className="list-unstyled list-inline social text-center">
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-av"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-notav"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-notav"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-notav"></i></li>
          <li className="list-inline-item "><i className="fa fa-star fa-3x cor-notav"></i></li>
          <h1 className="avalia-detalhe">{numero}</h1>
        </ul>
      </div>;
    }
  }


  const MaskedInput = ({ value, onChange, name, mask }) => {
    function handleChange(event) {
      onChange({
        ...event,
        target: {
          ...event.target,
          name,
          value: onlyNumbers(event.target.value),
        }
      });
    };

    return (
      <InputMask
        name={name}
        mask={mask}
        value={value}
        onChange={handleChange}
        className="form-control"
        id="exampleInputcnpj"
        aria-describedby="emailHelp"
        disabled
      />
    );
  };


  const formatNumber = (amount, decimalCount = 2, decimal = ",", thousands = ".") => {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  }


  useEffect(() => {
    setCodigoRest(localStorage.getItem("codigorest"));
    console.log(codigorest);
    api.get('/restaurante/cadastro/' + localStorage.getItem("codigorest"))
      .then(async response => {
        await
          setCodigo(response.data[0].codigo);
        setRazao(response.data[0].razao);
        setResponsavel(response.data[0].responsavel);
        setAvaliacao(response.data[0].avaliacao);
        setEmail(response.data[0].email);
        setErp(response.data[0].codigoerp);
        setCNPJ(response.data[0].cpfcnpj);
        setLojas(response.data[0].lojas);
        setEndereco(response.data[0].endereco); //colocar o endereço                
      })
      .catch(err => {
        console.log(err.data);
        return null;
      });
  }, []);


  return <div>
    <Menu modulo="REST" />
    <div className="container-fluid pagina-dados">
      <div className="offset-lg-3 col-lg-6">
        <h1> </h1>
        {GeraEstrela(avaliacao)}
        <form>
          <div className="row" >
            <div className="col-xl-4 col-lg-4 col-6 ">
              <label htmlFor="exampleInputEmail1" className="form-label">Código</label>
              <input type="text" value={codigorest} className="form-control" id="exampleInputid" aria-describedby="emailHelp" disabled />
            </div>
            <div className="col-xl-4 col-lg-4 col-6">
              <label htmlFor="exampleInputEmail1" className="form-label">Código ERP</label>
              <input type="text" value={codigoerp} className="form-control" id="exampleInputerp" aria-describedby="emailHelp" disabled />
            </div>
            <div className="col-xl-4 col-lg-4 col-12">
              <label htmlFor="exampleInputEmail1" className="form-label">CNPJ</label>
              <MaskedInput type="text" name="cnpj" mask="99.999.999/9999-99" value={formatLeadingZero(formatLeadingZero(cnpj))} />
            </div>
          </div>
          <div className="mb-3"></div>
          <div className="mb-3">
            <label htmlFor="exampleInputEmail1" className="form-label">Razão Social</label>
            <input /*onChange={(e) => setNome(e.target.value)}*/ value={razao} type="text" className="form-control" id="exampleInputrazao" aria-describedby="emailHelp" disabled />
          </div>

          <div className="mb-3">
            <label htmlFor="exampleInputEmail1" className="form-label">E-mail</label>
            <input /*onChange={(e) => setEmail(e.target.value)}*/ value={email} type="email" className="form-control" id="exampleInputemail" aria-describedby="emailHelp" disabled />
          </div>

          <div className="mb-3">
            <label htmlFor="exampleInputEmail1" className="form-label">Endereço</label>
            <input  /*onChange={(e) => setFone(e.target.value)}*/ value={endereco} type="text" className="form-control" id="exampleInputendereco" aria-describedby="emailHelp" disabled />
          </div>

          <div className="mb-3">
            <label htmlFor="exampleInputEmail1" className="form-label">Lojas Servidas</label>
            <table className="table table-hover table-bordered">
              <thead>
                <tr align='center' className="table-secondary">
                  <th scope="col" align='center'>Loja</th>
                  <th scope="col" align='center'>Marmitex</th>
                  <th scope="col" align='center'>Valor</th>
                </tr>
              </thead>
              <tbody>
                {
                  lojas.map((loja) => {
                    return <tr key={loja.loja}>
                      <td scope="row" align='center'>{formatLeadingZero(loja.loja)} </td>
                      <td align='center'>{loja.marmitex === 0 ? "NÃO" : "SIM"}</td>
                      <td align='right'>{formatNumber(loja.valor)}</td>
                    </tr>
                  })
                }
              </tbody>
            </table>
          </div>
        </form>
      </div>
      <Footer className="footer navbar-fixed-bottom" />
    </div>

  </div>
}

export default DadosRestaurante;
